export default "__VITE_ASSET__DkMVveCN__"